import styled from '@emotion/styled';

export const TextXLBoldWrapper = styled.p`
  font-size: 20px;
  font-weight: 700;
  font-family: 'Inter';
  color: ${({ theme }) => theme.palette?.brand.secondary.base}
`;
